const SESSION_STORAGE_ACCESS_TOKEN_KEY = 'cs_access_token'
const SESSION_STORAGE_REFRESH_TOKEN_KEY = 'cs_refresh_token'
const SESSION_STORAGE_REFRESHING_TOKEN_KEY = 'cs_refreshing_token'
const SESSION_STORAGE_LOCK_KEY = 'cs_lock'
const SESSION_STORAGE_ACCOUNT_ORGANIZATION_IDS_KEY = 'cs_account_organization_ids'

export const getAccessTokenFromSessionStorage = (): string | null => {
	return sessionStorage.getItem(SESSION_STORAGE_ACCESS_TOKEN_KEY)
}

export const setAccessTokenInSessionStorage = (accessToken: string): void => {
	sessionStorage.setItem(SESSION_STORAGE_ACCESS_TOKEN_KEY, accessToken)
}

export const getRefreshTokenFromSessionStorage = (): string | null => {
	return sessionStorage.getItem(SESSION_STORAGE_REFRESH_TOKEN_KEY)
}

export const setRefreshTokenInSessionStorage = (refreshToken: string): void => {
	sessionStorage.setItem(SESSION_STORAGE_REFRESH_TOKEN_KEY, refreshToken)
}

export const getAccountOrganizationIdsFromSessionStorage = (): string | null => {
	return sessionStorage.getItem(SESSION_STORAGE_ACCOUNT_ORGANIZATION_IDS_KEY)
}

export const setAccountOrganizationIdsInSessionStorage = (accountOrganizationIds: string): void => {
	sessionStorage.setItem(SESSION_STORAGE_ACCOUNT_ORGANIZATION_IDS_KEY, accountOrganizationIds)
}

export const getIsRefreshingTokenFromSessionStorage = (): boolean | null => {
	const value = localStorage.getItem(SESSION_STORAGE_REFRESHING_TOKEN_KEY)
	return value !== null ? value === 'true' : null
}

export const setIsRefreshingTokenInSessionStorage = (isRefreshing: boolean): void => {
	localStorage.setItem(SESSION_STORAGE_REFRESHING_TOKEN_KEY, isRefreshing.toString())
}

export const removeRefreshTokenfromSessionStorage = (): void => {
	sessionStorage.removeItem(SESSION_STORAGE_REFRESH_TOKEN_KEY)
}

export const removeAccessTokenfromSessionStorage = (): void => {
	sessionStorage.removeItem(SESSION_STORAGE_ACCESS_TOKEN_KEY)
}

export const removeRefreshingTokenfromSessionStorage = (): void => {
	sessionStorage.removeItem(SESSION_STORAGE_REFRESHING_TOKEN_KEY)
}

export const removeAccountOrganizationIdsfromSessionStorage = (): void => {
	sessionStorage.removeItem(SESSION_STORAGE_ACCOUNT_ORGANIZATION_IDS_KEY)
}

export const removeTokensFromSessionStorage = (): void => {
	removeRefreshTokenfromSessionStorage()
	removeAccessTokenfromSessionStorage()
	removeRefreshingTokenfromSessionStorage()
	removeAccountOrganizationIdsfromSessionStorage()
}

export const clearLockSessionStorage = (): void => {
	sessionStorage.removeItem(SESSION_STORAGE_LOCK_KEY)
}

export const lockSessionStorage = (): void => {
	sessionStorage.setItem(SESSION_STORAGE_LOCK_KEY, '1')
}

export const clearSessionStorage = (): void => {
	sessionStorage.clear()
}

export const isLocked = (): boolean => {
	return sessionStorage.getItem(SESSION_STORAGE_LOCK_KEY) === '1'
}
